import { Button } from 'react-bootstrap';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';
import React, { Suspense, useEffect, useState } from 'react';
import SpeciaLogo from '../resources/speciaLogo.png';
import reporterImg from '../resources/reporterMinimalist.png';

import { motion } from 'framer-motion';

import ArrowDownwardOutlinedIcon from '@mui/icons-material/ArrowDownwardOutlined';

import BGD from '../resources/Pattern.png';

import { useAuth } from 'react-oidc-context';
import { CircularProgress, Fab, Fade, Tooltip, Typography, styled, tooltipClasses } from '@mui/material';
import MyDigitalWorker from '../pages/MyDigitalWoker/MyDigitalWorker';
import QuickAccessBar from './QuickAccessBar';
import SessionExpiredModal from './SessionExpiredModal';
import TransparentButton from './TransparentButton';

const pageVariants = {
  initial: {
    opacity: 0,
  },
  in: {
    opacity: 1,
  },
  out: {
    opacity: 0,
  },
};

const pageTransition = {
  type: 'tween',
  ease: 'linear',
  duration: 0.3,
};

export default function HomeLayout({ children }) {
  const navigate = useNavigate();
  const auth = useAuth(); // Get the authentication context

  const location = useLocation();

  const tabs = auth.user?.profile.groups.includes('client-admin')
    ? [
        {
          name: 'Home',
          route: '/',
          onClick: () => { navigate('/'); },
        },
        {
          name: 'Clients',
          route: '/clients',
          onClick: () => { navigate('/clients'); },
        },
        {
          name: 'Settings',
          route: '/setting',
          onClick: () => { navigate('/setting'); },
        },
      ]
    : [
        {
          name: 'Home',
          route: '/',
          onClick: () => { navigate('/'); },
        },
        {
          name: 'Clients',
          route: '/clients',
          onClick: () => { navigate('/clients'); },
        },
      ];

  const [
    sessionExpired,
    setSessionExpired,
  ] = useState(false);

  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return { width, height };
  };

  const [
    windowDimensions,
    setWindowDimensions,
  ] = useState(getWindowDimensions());

  useEffect(() => {
    //   setIsLoading(true);

    //   fetch(`${window.origin}/api/digital-workers`, {
    //     method: 'GET',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Bearer ${auth.user?.access_token}`
    //     },
    // })
    // .then((response) => {
    //     if(response.status === 403){
    //         setSessionExpired(true)
    //         throw new Error('Session expired');
    //     }
    //     return response.json();
    // })
    // .then((data) => {
    //     // Mapping 'url' to 'path'
    //     console.log(data.data)
    //     const adjustedData = data.data.map(worker => ({
    //         ...worker,
    //         path: worker.url
    //     }));
    //     console.log(adjustedData)
    //     setWorkers(adjustedData);
    //     setIsLoading(false);
    // })
    // .catch((error) => {
    //     console.error('Failed to fetch workers:', error);
    // });

    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [auth]);

  // if(windowDimensions.height < windowDimensions.width)
  return (
    <>

      <div style={{ textAlign: 'left', position: 'relative', height: '100vh', display: 'flex', flexDirection: 'row' }}>
        {/* <MenuBar /> */}

        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100vh' }}>
          <>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
              <div style={{ paddingTop: '1.5vw', paddingLeft: '1.5vw', flex: 1, display: 'flex', alignItems: 'flex-start' }}>
                <div style={{ flex: 1, textAlign: 'left' }}>
                  <img src={SpeciaLogo} style={{ width: '3vw' }} />
                </div>
              </div>
              <div style={{ flex: 1, fontSize: '1.8vh', textAlign: 'center', flexDirection: 'row', marginLeft: '1.8vw', marginRight: '2vw', paddingTop: '2vw' }}>
                <div className="blur" style={{ display: 'inline-block', backgroundColor: 'rgb(0, 0, 0, 0.15)', borderRadius: '2vw', padding: '0.3vw' }}>

                  {tabs.map(item => (
                    <span
                      key={item.route}
                      style={{}}
                    >
                      <TransparentButton
                        id="workpaper-tab"
                        onClick={item.onClick}
                        selected={location.pathname == item.route}
                      >
                        {item.name}
                      </TransparentButton>
                    </span>
                  ))}
                </div>
              </div>
              <div style={{ paddingTop: '1.5vw', paddingRight: '1.5vw', flex: 1, display: 'flex', alignItems: 'flex-start' }}>
                <div style={{ flex: 1, textAlign: 'right' }}>
                  <QuickAccessBar />
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', flex: 1, height: 'calc(100vh - 5vw)' }}>
              <div style={{ flex: 1, display: 'flex', overflow: 'hidden' }}>
                <div style={{ flex: 1, width: '100%' }}>
                  <div style={{ height: 'calc(100vh - 5vw)', overflowY: 'hidden' }}>
                    <Suspense>
                      <motion.div
                        key={location.pathname}
                        initial="initial"
                        animate="in"
                        variants={pageVariants}
                        transition={pageTransition}
                      >
                        <Outlet />
                      </motion.div>
                    </Suspense>
                  </div>
                </div>
              </div>
            </div>
          </>
        </div>

      </div>

      {/* {!isLoading && <MyDigitalWorker/>} */}
    </>
  );
}
